import { formatDistanceToNow } from "date-fns";
const humanReadableDate = (dateString) => {
  if (!dateString) {
    return "";
  }
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn(`Invalid date string: ${dateString}`);
      return "";
    }
    return formatDistanceToNow(date, { addSuffix: true });
  } catch (error) {
    console.warn(`Error parsing date: ${dateString}`, error);
    return "";
  }
};
export {
  humanReadableDate
};
//# sourceMappingURL=date-utils.js.map
